import { getBlogs, Search, Response } from "../../../hooks/useBlogs";


export async function Submit(search: Search|null, page = 1, order = ''): Promise<Response> {
  const response = await getBlogs(search, page);
  
  if (!response?.results) return {
    results: [],
    pagination: {
      page: 0,
      pageCount: 0,
      pageSize: 10,
      total: 0
    }
  };

  return {
    results: response?.results,
    pagination: response?.pagination
  };
}